








































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import PersonaDireccion from "@/models/persona/personaDireccion.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Direccion from "@/models/direccion.model";
import EditarDireccionComponent from "@/components/direccion/editar-direccion.vue";
import DireccionComponent from "@/components/direccion/direccion.vue";

@Component({
  components: { EditarDireccionComponent }
})
export default class PerfilCiudadanoListaDirecciones extends BaseVue {
  @Prop() readonly personaId!: number;
  @Prop() readonly direccionHogarId!: number;
  protected repository!: BaseRepository<PersonaDireccion>;
  private showEdit: boolean = false;
  direccionAdded = new Direccion();

  direccionesTableConfig!: BTableConfig<PersonaDireccion>;
  direccionInit = new PersonaDireccion();
  direccionSeleccionada = new PersonaDireccion();
  hogarDireccionId = this.direccionHogarId
    ? this.copy(this.direccionHogarId)
    : 0;
  constructor() {
    super();
    this.repository = new BaseRepository<PersonaDireccion>("personadireccion");
  }
  init() {
    this.direccionSeleccionada = this.map<PersonaDireccion>(this.direccionInit);
  }
  created() {
    let props = [];
    props.push(
      new TipoTramiteComponentProp("personaId", "number"),
      new TipoTramiteComponentProp("direccionHogarId", "number")
    );
    this.$emit("render", props);
  }
  onLoadTable(config: BTableConfig<PersonaDireccion>) {
    this.direccionesTableConfig = config;
    if (this.hogarDireccionId)
      this.direccionesTableConfig.data = this.direccionesTableConfig.data.filter(
        x => x.direccionId != this.hogarDireccionId
      );
  }

  closeEdit() {
    this.showEdit = false;
  }

  public async onUpdate() {
    let ref = this.$refs.direccion_edit as DireccionComponent;
    let isValid = await ref.isValid();
    if (!isValid) return;

    if (this.direccionAdded.id) {
      let modelo = new PersonaDireccion();
      modelo = this.copy(this.direccionSeleccionada);
      modelo.direccion = this.map<Direccion>(this.direccionAdded);

      await this.repository.update(modelo.id as number, modelo);
      this.direccionSeleccionada = new PersonaDireccion();
      
      this.recargarTabla();
      this.showEdit = false;
      this.$buefy.toast.open({
        message: "La dirección se actualizó exitosamente",
        type: "is-success",
        position: "is-top-right"
      });
    }
  }

  onSelect(selected: PersonaDireccion, oldSelected: PersonaDireccion) {
    this.direccionSeleccionada = selected;
  }

  editar(direccion: Direccion) {
    if (direccion) {
      this.direccionAdded = this.map<Direccion>(direccion);
      this.showEdit = true;
    }
  }

  quitar() {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar esta dirección?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => this.eliminar()
    });
  }

  async eliminar() {
    try {
      let id = this.direccionSeleccionada.id as number;
      await this.repository.delete(id);
      this.operationSuccess("Dirección eliminada!");
      this.recargarTabla();
      this.init();
    } catch (e) {
      this.operationFailed(e);
    }
  }

  recargarTabla() {
    if (this.direccionesTableConfig.reload)
      this.direccionesTableConfig.reload();
  }
}
